import React from "react";
import MainMenu from "./MainMenu";
import PageContent from "./PageContent";
import Routing from "components/routing/Routing";
import FlowLayout from "./FlowLayout";
import "./Layout.scoped.scss";
import TitleBar from "./TitleBar";
import SystemMessages from "./SystemMessages";
import { Outlet } from "react-router-dom";

const Layout: React.FC = () =>
  <div
    className="site"
  >
    <TitleBar />
    <div
      className="lower-section"
    >
      <MainMenu />
      <FlowLayout>
        <SystemMessages />
        <PageContent>
          <Outlet />
        </PageContent>
      </FlowLayout>
    </div>
  </div>;

export default Layout;